import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.naziv === '' || formData.naziv === null) {
    toast.error('Naziv je obavezno polje.');
    return true;
  }
  if (
    formData.marza === '' ||
    formData.marza === null ||
    formData.marza === 0
  ) {
    toast.error('Marža mere  je obavezno polje.');
    return true;
  }

  return false;
};
